import { render, staticRenderFns } from "./wemeidaConfig.vue?vue&type=template&id=6711e08c&scoped=true"
import script from "./wemeidaConfig.vue?vue&type=script&lang=js"
export * from "./wemeidaConfig.vue?vue&type=script&lang=js"
import style0 from "./wemeidaConfig.vue?vue&type=style&index=0&id=6711e08c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6711e08c",
  null
  
)

export default component.exports